import React, { useEffect, useState } from "react";

import { handleNumeroItemSCColumn, handleProdutoSCColumn, handlePrioridadeSCColumn, handleQtdValorSCColumn, handleGrupoProdutoSCColumn }  from "../GridCell/Solicitacao";
import ResponsiveDataTable from "../DataTable";
import { formatDateColumn, RetornaUsuarioLogado } from "../../contents/VariaveisGlobais";
import { Row, Col, FormControl, FormLabel } from "react-bootstrap";
import ConsumoTOTVS_POST from "../../../backend/ConsumoTotvs";
import { toast } from "react-toastify";
import DisparaEmail from "../../../backend/DisparaEmail";
import SelectComprador from "../Select/Comprador";

const SelecaoSolicitacaoCompra = (DisparaBootBox, FecharBox, dataSolicitacaoCompra, FecharBoxDefault) => {
    var campoMotivo = "";
    var campoVincularComprador = {value: "", label: ""};
    
    const columns = [
        { Header: 'SC',                 accessor: "C1_NUM",         Cell: handleNumeroItemSCColumn },
        { Header: 'Produto/Serviço',    accessor: "C1_PRODUTO",     Cell: handleProdutoSCColumn },
        { Header: 'Grupo',              accessor: "BM_DESC" },
        { Header: 'Prioridade',         accessor: "C1_XFLUXSC",     Cell: handlePrioridadeSCColumn },
        { Header: 'Qtde. / Custo Meta', accessor: 'C1_QUANT',       Cell: handleQtdValorSCColumn },
        { Header: 'Emissão',            accessor: 'C1_EMISSAO',     Cell: formatDateColumn },
        { Header: 'Previsão',           accessor: 'NECESSIDADE',    Cell: formatDateColumn },
    ];

    const Mensagem = (
        <Row>
            <Col md="12" xs="12">
                <ResponsiveDataTable
                    columns={columns}
                    data={dataSolicitacaoCompra} // Carregar dados conforme necessário
                    buttons={[]}
                    isIgnorar={true}
                    habilitaCheckBox={true}
                    linhaCondicional={(item) => item.C1_XFLUXSC === '3'}
                />
            </Col>
        </Row>
    );

    const handleCampoComprador = (e) =>{
        campoVincularComprador = e;
    }

    const handleCampoMotivo = (e) =>{
        campoMotivo = e.target.value.toUpperCase();
    }

    const vincularSC = async() => {
        const Mensagem = ( <>
                <SelectComprador
                    changeComprador={handleCampoComprador}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaComprador, label: '✓ Confirmar' },
            { variant: 'secondary', action: FecharBoxDefault, label: '✗ Cancelar' }
        ]
        
        campoMotivo = ''

        DisparaBootBox('Confirma Vinculo de Comprador ?', Mensagem, buttonsRender, null, null)        
    }

    const devolverSC = async() => {
        const Mensagem = ( <>
                <FormLabel>Motivo da Devolução</FormLabel>
                <FormControl
                    type='text'                    
                    onChange={handleCampoMotivo}
                    maxLength={254}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaDevolucao, label: '✓ Confirmar' },
            { variant: 'secondary', action: FecharBoxDefault, label: '✗ Cancelar' }
        ]
        
        campoMotivo = ''

        DisparaBootBox('Confirma Devolução ?', Mensagem, buttonsRender, null, null)        
    }

    const handleConfirmaComprador = async() => {
        if (!campoVincularComprador && !campoVincularComprador.value.trim()){
            toast.warning('A seleção do Comprador é obrigatório.');
            return
        }

        const scSelecionada = dataSolicitacaoCompra.filter( (item) => item.Check === true);
        const empresaFilial = dataSolicitacaoCompra[0].EMPRESA + dataSolicitacaoCompra[0].C1_FILIAL;
        const scJSON = scSelecionada.map( (item) => {
            const solicitacao = {
                NUMERO: item.C1_NUM,
                ITEM: item.C1_ITEM,
                COMPRADOR: campoVincularComprador.label.split('-')[0].trim(),
            };

            return solicitacao;
        })

        const valueJSON = JSON.stringify(scJSON)
        const oRetorno = await ConsumoTOTVS_POST('COMPRADORSOLICITACAOCOMPRA', valueJSON, empresaFilial)

        if (oRetorno.error === '00'){
            toast.success("Vinculo da SC ao Comprador realizado com Sucesso!")
        }

        FecharBoxDefault()
    }

    const handleConfirmaDevolucao = async() => {
        if (!campoMotivo){
            toast.warning('O prenchimento do Motivo da Devolução é obrigatório.');
            return
        }

        const MotivoDevolucao = campoMotivo
        const scSelecionada = dataSolicitacaoCompra.filter( (item) => item.Check === true);
        const empresaFilial = dataSolicitacaoCompra[0].EMPRESA + dataSolicitacaoCompra[0].C1_FILIAL;
        const scJSON = scSelecionada.map( (item) => {
            const solicitacao = {
                NUMERO: item.C1_NUM,
                ITEM: item.C1_ITEM,
                STATUS: "D",
                MOTIVO: campoMotivo,
            };

            return solicitacao;
        })

        const valueJSON = JSON.stringify(scJSON)
        const oRetorno = await ConsumoTOTVS_POST('DEVOLVERSOLICITACAOCOMPRA', valueJSON, empresaFilial)

        if (oRetorno.error === '00'){
            const usuarioLogado = RetornaUsuarioLogado()

            oRetorno.data.map( (item) => {
                const dadosEnvio = {
                    showMsg: true,
                    destinatario: item.EMAIL,
                    assunto: `Devolução de Solicitação de Compras - ${item.C1_NUM}`,
                    corpo: `<h1>Aviso de Devolução da sua Solicitação de Compras</h1>
                            <p>Prezado(a) ${item.USUARIO},</p>
                            <p>Informamos que sua <strong>Solicitação de Compras - ${item.C1_NUM}</strong> foi <strong>devolvida</strong> pelo setor de <strong>Suprimentos</strong>, conforme avaliação do comprador <strong>${usuarioLogado.nome}</p>
                            <ul>
                            <li><strong>Motivo da devolução:</strong> ${MotivoDevolucao}</li>
                            </ul>
                            <p>Caso tenha dúvidas ou precise de mais informações, consulte o comprador responsável.</p>
                            <p>Agradecemos pela sua colaboração.</p>`,
                    sender: usuarioLogado.email
                }

                DisparaEmail(dadosEnvio);
            })

            dataSolicitacaoCompra = dataSolicitacaoCompra.filter( (item) => item.Check === false);
        }

        FecharBoxDefault()
    }

    const buttonsRender = [
        { variant: 'success', action: vincularSC, label: 'Vincular Comprador' },
        { variant: 'secondary', action: devolverSC, label: 'Devolver' },
        { variant: 'primary', action: FecharBox, label: 'Aplicar' }
    ];

    DisparaBootBox('Selecione a(s) Solicitação(ões) de Compra(s)', Mensagem, buttonsRender, 0, FecharBox, 'xl', false, true, true);        
};

export default SelecaoSolicitacaoCompra;